
export class OverlayImage{
    constructor(url, topLeftCoord, bottomRightCoord, boundTopLeftCoord, boundBottomRightCoord, zoom){
        this.url = url;
        this.topLeftCoord = topLeftCoord;
        this.bottomRightCoord = bottomRightCoord;
        this.boundTopLeftCoord = boundTopLeftCoord;
        this.boundBottomRightCoord = boundBottomRightCoord;
        this.zoom = zoom;
    }
}
